import { render, staticRenderFns } from "./CollectionEdit.vue?vue&type=template&id=0f019792&scoped=true&"
import script from "./CollectionEdit.vue?vue&type=script&lang=js&"
export * from "./CollectionEdit.vue?vue&type=script&lang=js&"
import style0 from "./CollectionEdit.vue?vue&type=style&index=0&id=0f019792&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f019792",
  null
  
)

export default component.exports